export const NODE_ENV = process.env.NODE_ENV
export const CLOUD9_API = process.env.REACT_APP_API_URL
//export const CLOUD9_API = 'http://localhost:9900'